import React, { useState, useEffect } from "react";
import { Tabs, Col, Row, Checkbox, Select, Button, message, Input } from "antd";
import { fuzzyFilterNestedArray, notificationDataCategories } from "../../utils/commChannelUtils";

import "./commConfiguration.css";
import { getData, updateData } from "../../utils/dataResolve";
import getSiteSubRoleSiteId from "../../queries/getSiteSubRoleSiteId";
import { createObjectWithArray, findWithId, updateDataWithId } from "../../utils/basicLoops";
import updateCommChannelSetting from "../../mutation/updateCommChannelSetting";
import getCommChannelSettingByDomain from "../../queries/getCommChannelSettingByDomain";
import useDebouncer from "../../hooks/useDebouncer";

const { TabPane } = Tabs;
const Option = Select.Option;
const { Search } = Input;

const CommConfiguration = (props) => {
  const [initialData, setInitialData] = useState({
    users: [],
    commChannels: [],
  });
  const [commChannels, setCommChannels] = useState(JSON.parse(JSON.stringify(notificationDataCategories)));
  const [header, setHeader] = useState(commChannels[0].value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const siteData = props.siteData;
    // console.log("siteData :::", siteData);
    const callPromise = async () => {
      try {
        const [{ items = [] }, commChannels] = await Promise.all([
          getData(
            props.client,
            {
              query: getSiteSubRoleSiteId,
              variables: {
                siteId: siteData.siteId,
                nextToken: "",
              },
            },
            "getSiteSubRoleSiteId"
          ),
          getData(
            props.client,
            {
              query: getCommChannelSettingByDomain,
              variables: {
                domain: siteData.fqdn,
              },
              fetchPolicy: "no-cache",
            },
            "getCommChannelSettingByDomain"
          ),
        ]);
        const users = JSON.parse(JSON.stringify(items));
        // console.log({ users, commChannels });
        users.unshift({
          name: "Admin",
          username: siteData.userName,
          mobile: siteData.contactNumber,
          emailId: siteData.contactEmail,
        });
        // console.log("users :::", users);
        const commData = createData(commChannels.configs);
        // console.log("commData :::", commData);
        // console.log({ users, commData });
        setCommChannels(commData);
        setInitialData((prevState) => new Object({ ...prevState, users }));
      } catch (err) {
        console.log("err :::", err);
      }
    };

    callPromise();
  }, [props.siteData.fqdn]);

  const createData = (configs) => {
    let iterator, i, innerIterator, j, k, event, config, temp, l;
    // const commData = JSON.parse(JSON.stringify(commChannels));
    const commData = [...commChannels];
    if (!(configs && configs.length)) return commData;
    const configsObj = createObjectWithArray(configs, "code");
    // console.log("configsObj :::", configsObj);
    for (i = 0; i < commData.length; i++) {
      iterator = commData[i];
      for (j = 0; j < iterator.children.length; j++) {
        innerIterator = iterator.children[j];
        temp = [];
        for (k = 0; k < innerIterator.children.length; k++) {
          event = innerIterator.children[k];
          // console.log("event :::", event);
          if (configsObj[event.value]) {
            config = configsObj[event.value];
            if (config.commList && config.senderList) {
              if (config.commList.includes("TELEGRAM")) {
                event.telegram = true;
              }
              if (config.commList.includes("EMAIL")) {
                event.email = true;
              }
              event.usernames = [];
              for (l = 0; l < config.senderList.length; l++) {
                event.usernames.push(config.senderList[l].username);
              }
            }
          }
          temp.push(event);
        }
        iterator.children[j].children = temp;
      }
    }
    return commData;
  };

  const handleDataUpdate = (value, subHeader, updation) => {
    // console.log("updation :::", { value, updation });
    // const commData = JSON.parse(JSON.stringify(commChannels));
    const commData = [...commChannels];

    let response = findWithId(commData, header, "value");
    // console.log("main response :::", response);
    const mainHeaderData = response.response;
    const mainIndex = response.index;

    response = findWithId(mainHeaderData.children, subHeader, "value");
    // console.log("sub response :::", response);
    const subHeaderData = response.response;
    const subIndex = response.index;

    response = updateDataWithId([...subHeaderData.children], value, "value", updation);
    console.log("response :::", response);
    commData[mainIndex].children[subIndex].children = response;

    // console.log("commData :::", commData);
    setCommChannels(commData);
  };

  const handleTabChange = (event) => {
    setHeader(event);
  };

  const handleSubmit = async () => {
    try {
      const commData = [...commChannels];
      const configs = [];
      let iterator, i, innerIterator, j, k, event, user, temp, l;
      const userObj = createObjectWithArray(initialData.users, "username");
      for (i = 0; i < commData.length; i++) {
        iterator = commData[i];
        for (j = 0; j < iterator.children.length; j++) {
          innerIterator = iterator.children[j];
          for (k = 0; k < innerIterator.children.length; k++) {
            event = innerIterator.children[k];
            if (event.usernames && event.usernames.length && (event.email || event.telegram)) {
              temp = {
                code: event.value,
                commList: [],
                senderList: [],
              };
              if (event.telegram) {
                temp.commList.push("TELEGRAM");
              }
              if (event.email) {
                temp.commList.push("EMAIL");
              }
              for (l = 0; l < event.usernames.length; l++) {
                user = userObj[event.usernames[l]];
                if (!user) break;
                temp.senderList.push({
                  username: user.username,
                  mobile: user.mobile,
                  email: user.emailId,
                  name: user.name,
                });
              }
              configs.push(temp);
            }
          }
        }
      }
      setLoading(true);
      const response = await updateData(
        props.client,
        {
          mutation: updateCommChannelSetting,
          variables: {
            input: {
              domain: props.siteData.fqdn,
              configs,
            },
          },
        },
        "updateCommChannelSetting"
      );
      console.log("response :::", response);
      setLoading(false);
      message.success("Configuration saved successfully...");
      props.handleCommCancel();
    } catch (err) {
      console.log("err :::", err);
      message.error(`${err}`);
    }
    // console.log("configs :::", configs);
  };

  // console.log("notificationDataCategories :::", notificationDataCategories);

  return (
    <div>
      <Button
        type="primary"
        htmlType="submit"
        className="block submit-button-green"
        style={{ marginBottom: 12, cursor: "pointer", marginLeft: "auto" }}
        onClick={handleSubmit}
        loading={loading}
      >
        SAVE
      </Button>
      <Tabs type="card" className="planTabs tab-over-flow" onChange={handleTabChange}>
        {commChannels.map((mainHeader) => (
          <TabPane tab={mainHeader.name} key={mainHeader.value}>
            <CommConfigurationSettings data={mainHeader} users={initialData.users} handleDataUpdate={handleDataUpdate} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

const CommConfigurationSettings = (props) => {
  const { data, users, handleDataUpdate } = props;

  const [selectedCategory, setselectedCategory] = useState(data.children[0]);
  const [search, setSearch] = useState("");
  // const [subHeaderData, setSubHeaderData] = useState(JSON.parse(JSON.stringify(data.children)));
  const [subHeaderData, setSubHeaderData] = useState(data.children);

  // console.log("subHeaderData :::", subHeaderData);

  const debouncedSearchTerm = useDebouncer(search, 700);

  const handleSubHeaderClick = (subHeader) => {
    setselectedCategory(subHeader);
  };

  const handleUpdate = (value, selectedCategoryValue, updation, channelData) => {
    // console.log("channelData :::", channelData);
    const commData = [...channelData];

    let response = findWithId(commData, selectedCategoryValue, "value");
    // console.log("sub response :::", response);
    const subHeaderData = response.response;
    const subIndex = response.index;

    response = updateDataWithId([...subHeaderData.children], value, "value", updation);
    // console.log("response :::", response);
    commData[subIndex].children = response;

    setSubHeaderData(commData);

    handleDataUpdate(value, selectedCategoryValue, updation);
  };

  const handleTelegramCheckChange = (event, value) => {
    handleUpdate(value, selectedCategory.value, { telegram: event.target.checked }, subHeaderData);
  };

  const handleEmailCheckChange = (event, value) => {
    handleUpdate(value, selectedCategory.value, { email: event.target.checked }, subHeaderData);
  };

  const handleUserSelectChange = (event, value) => {
    // console.log("event :::", event);
    // const userDetails = findWithId(users, event, "username");
    // handleUpdate(value, selectedCategory.value, { username: userDetails.username, name: userDetails.name, userDetails });
    handleUpdate(value, selectedCategory.value, { usernames: event }, subHeaderData);
  };

  const handleSearch = (e) => {
    let searchedItem = e.target.value;
    setSearch(searchedItem);
  };

  useEffect(() => {
    let searchResults = data.children;
    if (debouncedSearchTerm) {
      searchResults = fuzzyFilterNestedArray(data.children, debouncedSearchTerm);
    }

    console.log("searchResults :::", searchResults);
    setSubHeaderData(searchResults);
    setselectedCategory(searchResults[0] ? searchResults[0] : { children: [] });
  }, [debouncedSearchTerm]);

  return (
    <>
      <Row>
        <Col span={8}>
          <Search placeholder=" Search By Item Name/ Category Name" onChange={handleSearch} allowClear />
        </Col>
      </Row>
      <Row className="subheader-container mt-16" gutter={16}>
        <div>
          <Col span={5}></Col>
          <Col span={19}>
            <Col className="fw-bold" span={8}>
              Events
            </Col>
            <Col className="fw-bold" span={3}>
              Telegram
            </Col>
            <Col className="fw-bold" span={3}>
              Email
            </Col>
            <Col className="fw-bold" span={10}>
              Users
            </Col>
          </Col>
        </div>
        <div>
          <Col className="sub-categories flex flex-direction-column gap-16" span={5}>
            {subHeaderData.map((subHeader) => {
              return (
                <span
                  key={subHeader.value}
                  className={`${subHeader.value === selectedCategory.value && "active"}`}
                  onClick={() => handleSubHeaderClick(subHeader)}
                >
                  {subHeader.name}
                </span>
              );
            })}
          </Col>
          <Col span={19} className="flex flex-direction-column gap-16 mt-16">
            {selectedCategory.children.map((child) => {
              return (
                <div key={child.value}>
                  <Col span={8}>{child.name}</Col>
                  <Col span={3}>
                    <Checkbox checked={child.telegram} onChange={(event) => handleTelegramCheckChange(event, child.value)} />
                  </Col>
                  <Col span={3}>
                    <Checkbox checked={child.email} onChange={(event) => handleEmailCheckChange(event, child.value)} />
                  </Col>
                  <Col span={10}>
                    <Select
                      className="w-100"
                      getPopupContainer={(trigger) => trigger.parentNode}
                      showSearch
                      optionFilterProp="children"
                      placeholder="Select User"
                      onChange={(event) => handleUserSelectChange(event, child.value)}
                      value={child.usernames}
                      mode="multiple"
                    >
                      {users.map((user) => (
                        <Option value={user.username} key={user.username}>
                          {user.name}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                </div>
              );
            })}
          </Col>
        </div>
      </Row>
    </>
  );
};

export default CommConfiguration;
